<template>
    <div class="c-standard-summary">
        <b-card no-body>
            <div slot="header">
                <b-badge :class="{ 'badge-success': dataBookingCount < dataBookingLimit, 'badge-danger': dataBookingCount >= dataBookingLimit}" v-if="dataBookingLimit !== '' && dataBookingLimit > 0" class="p-1">{{dataBookingCount}} / {{dataBookingLimit}}</b-badge>
                <b-badge v-else class="badge-info p-1">{{dataBookingCount}}</b-badge>
                {{caption}}
                <div class="card-header-actions pull-right">
                    <b-link href="#" @click="open" class="card-header-action btn-setting">
                        <i class="fa fa-plus"></i>&nbsp;{{Core.Definition.getDefinition('Réservation')}}
                    </b-link>
                </div>
            </div>
            <b-card-body>

                <table :class="{ 'table-responsive': Core.Display.isMobile() }" class="table table-striped">
                    <thead>
                    <th>
                        {{Core.Definition.getDefinition('Date')}}
                    </th>
                    <th>
                        {{Core.Definition.getDefinition('Événement')}}
                    </th>
                    <th colspan="2">
                        {{Core.Definition.getDefinition('Participant')}}
                    </th>
                    <th></th>
                    <th>
                        {{Core.Definition.getDefinition('État')}}
                    </th>
                    <th width="50px"></th>
                    </thead>
                    <tbody>
                    <tr v-if="dataBookings.length === 0">
                        <td colspan="8">{{Core.Definition.getDefinition('Aucune participation à afficher')}}</td>
                    </tr>
                    <tr :key="bookingIndex" v-for="booking, bookingIndex in dataBookings">
                        <td>
                            {{Core.Value.readable('dateTime', 'start', booking.start)}}
                        </td>
                        <td>
                            {{booking.title}}
                        </td>
                        <td>
                            <div v-if="booking.user.firstname !== ''">
                                <label>{{booking.user.firstname}} {{dataBookings[bookingIndex].user.lastname}}</label><br/>
                            </div>
                            <UserAction
                                    v-if="booking.user.firstname === ''"
                                    v-model="dataBookings[bookingIndex].user"
                                    :options="{ reset: { display: false }, add: { display: true }  }"></UserAction>
                        </td>
                        <td>
                            <b-button @click="removeUser(bookingIndex)" v-if="booking.user.firstname !== ''" class="mr-1 btn btn-sm" variant="danger"><i class="fa fa-times"></i></b-button>
                        </td>
                        <td>
                            <InputQuantity class="mt-1" v-model="booking.quantity"></InputQuantity>
                        </td>
                        <td>
                            {{Core.Value.readable('select', 'status', booking.status, Mantle.EventDateBooking.statusOptions())}}
                        </td>
                        <td>
                            <b-button @click="onTrashClick(bookingIndex)" class="btn btn-danger btn-sm"><i
                                    class="fa fa-trash-o"></i></b-button>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <ModalInstanceSelector
                        :caption="Core.Definition.getDefinition('Nouvelle participation')"
                        ref="modalInstanceSelector"
                        root="/event-date/list"
                        v-model="dataEventDates"
                        :multiple="true"
                        :searchFormStructure="{
                                rows: [
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'start'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'eventId'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'type'
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                fields: [
                                    {
                                        id: 'start',
                                        type: 'datePicker',
                                        isInline: false,
                                        label: Core.Definition.getDefinition('Date'),
                                        value: null,
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'type',
                                        type: 'select',
                                        label: Core.Definition.getDefinition('Type d\'événement'),
                                        value: null,
                                        onSelect: function() {}
                                    },
                                    {
                                        id: 'eventId',
                                        type: 'select',
                                        label: Core.Definition.getDefinition('Événement'),
                                        value: null,
                                        onSelect: function() {}
                                    }
                                ]
                         }"
                        :options="{
                                pagination: true,
                                header: true,
                                responsive: false,
                                striped: true,
                                headerStyle: '1',
                                emptyText: Core.Definition.getDefinition('Aucune date à afficher'),
                                borderVariant: 'white',
                                noBody: true
                         }"
                        :columns="[
                                {
                                    label: Core.Definition.getDefinition('Début'),
                                    key: 'start',
                                    type: 'date',
                                    format: 'DD MMM YYYY HH:mm',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Fin'),
                                    key: 'end',
                                    type: 'date',
                                    format: 'DD MMM YYYY HH:mm',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Titre'),
                                    key: 'title',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Type'),
                                    key: 'type',
                                    type: 'select',
                                    sortable: true
                                }
                         ]"></ModalInstanceSelector>
            </b-card-body>
        </b-card>
    </div>
</template>


<script>
    import ModalInstanceSelector from './ModalInstanceSelector'
    import ModalUser from './ModalUser'
    import UserAction from './UserAction'
    import InputQuantity from './InputQuantity'

    export default {
        name: 'BookingSummary',
        components: {
            InputQuantity,
            ModalInstanceSelector,
            ModalUser,
            UserAction
        },
        props: {
            bookingLimit: {
                type: String | Number,
                default: 0
            },
            bookingCount: {
                type: String | Number,
                default: 0
            },
            caption: {
                type: String,
                default: ''
            },
            id: {
                type: String,
                default: ''
            },
            form: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            fieldRefs: {
                type: Array,
                default: function () {
                    return []
                }
            },
            value: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
            value: {
                handler(val) {
                    this.dataBookings = val
                },
                deep: true
            },
            dataBookings: {
                handler(val) {

                    let bookingCount = 0
                    for(let booking in  this.dataBookings) {
                        booking =  this.dataBookings[booking]
                        bookingCount += parseInt(booking.quantity)
                    }
                    this.dataBookingCount = bookingCount

                    this.$emit('input', val)
                },
                deep: true
            },
            dataEventDates: {
                handler(val) {
                    this.evalBookings()
                },
                deep: true
            }
        },
        mounted() {
            this.dataBookings = this.value
            this.dataBookingLimit = this.bookingLimit
            this.dataBookingCount = this.bookingCount
        },
        data: () => {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataBookings: [],
                dataTrashModal: {
                    show: false,
                    index: ''
                },
                dataEventDates: [],
                dataBookingLimit: '',
                dataBookingCount: 0
            }
        },
        methods: {
            evalBookings() {
                for(let eventDateIndex in this.dataEventDates) {
                    let eventDate = this.dataEventDates[eventDateIndex].instance
                    let quantity = this.dataEventDates[eventDateIndex].quantity
                    if (this.dataBookings.length > 0) {
                        for(let booking in this.dataBookings) {
                            booking = this.dataBookings[booking]
                            let sameBookings = Core.Array.findAllByKey(this.dataBookings, 'eventDateId', eventDate.id)
                            if (sameBookings === false || sameBookings.length < quantity) {
                                this.addBooking(eventDate.id, eventDate.title, eventDate.start, eventDate.end, Mantle.EventDateBooking.statusRegistered)
                            }
                        }
                    } else {
                        this.addBooking(eventDate.id, eventDate.title, eventDate.start, eventDate.end, Mantle.EventDateBooking.statusRegistered)
                    }
                }
            },
            addBooking(eventDateId, title, start, end, status) {
                this.dataBookings.push(
                    {
                        quantity: '1',
                        eventDateId: eventDateId,
                        title: title,
                        start: start,
                        end: end,
                        status: status,
                        user: {
                            birthDate: null,
                            firstname: '',
                            lastname: '',
                            email: '',
                            phone:'',
                            mobile:'',
                            country: null,
                            province: null,
                            city: '',
                            address: '',
                            zipcode:''
                        }
                    }
                )
            },
            onTrashClick(bookingIndex) {
                this.dataBookings.splice(bookingIndex, 1)
                this.eval()
            },
            open() {
                this.dataEventDates = []
                this.$refs.modalInstanceSelector.open = true
            },
            removeUser(bookingIndex) {
                this.dataBookings[bookingIndex].user = {
                    birthDate: null,
                    firstname: '',
                    lastname: '',
                    email: '',
                    phone:'',
                    mobile:'',
                    country: null,
                    province: null,
                    city: '',
                    address: '',
                    zipcode:''
                }
            }
        }
    }
</script>
